module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(Number(_vm.userInfo.crmCustomerType) === 1) ? _c('div', [_c('div', {
    staticClass: "personal-center-form__section_person"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    staticStyle: {
      "color": "#EB662B"
    },
    attrs: {
      "label": "个人信息",
      "name": "first"
    }
  }, [_c('router-view')], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 2) ? _c('div', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("企业信息")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "myInfoForm",
    attrs: {
      "label-width": '50%',
      "model": _vm.enterpriseInfoFormModel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入客户名称",
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2,
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.customerName),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "customerName", $$v)
      },
      expression: "enterpriseInfoFormModel.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号",
      "prop": "enterpriseNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入营业执照号",
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2,
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "股东人数",
      "prop": "enterprisePartnerNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入股东人数"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterprisePartnerNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterprisePartnerNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterprisePartnerNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属行业",
      "prop": "enterpriseIndustry"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择所属行业"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseIndustry),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseIndustry", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseIndustry"
    }
  }, _vm._l((_vm.belongIndustryList), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "label": item.itemName,
        "value": item.itemValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业规模",
      "prop": "enterpriseScale"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择企业规模"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseScale),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseScale", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseScale"
    }
  }, _vm._l((_vm.corporationscaleList), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "label": item.itemName,
        "value": item.itemValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.getCityList
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.province),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "province", $$v)
      },
      expression: "enterpriseInfoFormModel.province"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择城市"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.city),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "city", $$v)
      },
      expression: "enterpriseInfoFormModel.city"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址",
      "prop": "enterpriseRegAddr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入注册地址",
      "maxlength": 30,
      "resize": "none",
      "rows": 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseRegAddr),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseRegAddr", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseRegAddr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地址",
      "prop": "enterpriseOfficeAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入办公地址",
      "maxlength": 30,
      "resize": "none",
      "rows": 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOfficeAddress", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOfficeAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业性质",
      "prop": "enterpriseType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseType", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseType"
    }
  }, _vm._l((_vm.enterpriseInfoFormModel.enterpriseTypeArray), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "enterpriseRegMoney_main",
    attrs: {
      "label": "注册资金",
      "prop": "enterpriseRegMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入注册资金"
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseRegMoney),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseRegMoney", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseRegMoney"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "enterpriseRegMoney_unit"
  }, [_vm._v("万")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人',
      "prop": "enterpriseLegalUser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人',
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2,
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUser),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUser", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号',
      "prop": "enterpriseLegalIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号',
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2,
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalIdNo),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalIdNo", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人联系电话' : '代理人联系电话',
      "prop": "enterpriseLegalUserPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人联系电话' : '请输入法定代表人联系电话',
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2,
      "maxlength": 11
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUserPhone),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUserPhone", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUserPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册类型",
      "required": true,
      "prop": "registrationType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.registrationType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "registrationType", $$v)
      },
      expression: "enterpriseInfoFormModel.registrationType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("多证合一")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("组织机构代码证号")])], 1)], 1), _vm._v(" "), [(Number(_vm.enterpriseInfoFormModel.registrationType) === 0) ? _c('el-form-item', {
    attrs: {
      "label": "组织机构代码证号",
      "prop": "enterpriseOrganizingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入组织机构代码证号",
      "maxlength": 30,
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOrganizingNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOrganizingNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOrganizingNumber"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "社会信用代码号",
      "prop": "enterpriseOrganizingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入社会信用代码号",
      "maxlength": 30,
      "disabled": _vm.isEditable === 1 || _vm.authStatus === 1 || _vm.authStatus === 2
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOrganizingNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOrganizingNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOrganizingNumber"
    }
  })], 1)], _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "国税登记证号",
      "prop": "enterpriseNationalNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入国税登记证号",
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseNationalNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseNationalNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseNationalNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地税登记证号",
      "prop": "enterpriseGovernmentNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入地税登记证号",
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseGovernmentNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseGovernmentNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseGovernmentNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记机关",
      "prop": "enterpriseRegOrgan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入登记机关",
      "maxlength": 30
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseRegOrgan),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseRegOrgan", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseRegOrgan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "从业人数",
      "prop": "enterpriseEmployeeNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入从业人数",
      "maxlength": 10
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseEmployeeNum),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseEmployeeNum", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseEmployeeNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营范围",
      "prop": "enterpriseScope"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入经营范围",
      "maxlength": 1000,
      "resize": "none",
      "rows": 10
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseScope),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseScope", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseScope"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成立背景",
      "prop": "enterpriseFoundExplain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入成立背景",
      "maxlength": 1000,
      "resize": "none",
      "rows": 10
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseFoundExplain),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseFoundExplain", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseFoundExplain"
    }
  })], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    staticStyle: {
      "background": "#84A232"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交\n          ")])], 1)], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d41d949e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/MyInfo.vue
// module id = 1095
// module chunks = 1